<template>
  <a-modal
    v-model="isShow"
    centered
    :width="800"
    :mask-closable="false"
    :ok-button-props="{ props: { loading: submitting } }"
    title="取消划拨"
    @ok="handleSubmit"
  >
    <a-row>
      <a-form
        class="iotplt-compact-form"
        :form="form"
        @submit="handleSubmit"
      >
        <a-col :span="24">
          <a-form-item
            :wrapper-col="{ span: 24 }"
          >
            <common-card-input
              :rows="15"
              ref="iccidInput"
              v-decorator="['iccids', {
                initialValue: { data: this.iccids },
                rules: [{ validator: checkIccids }],
              }]"
            />
          </a-form-item>
        </a-col>

        <a-col :span="24">
          <a-form-item
            label="备注"
            extra="*将卡从直属下级客户名下收回，还原为未划拨给下级的状态；不产生账单"
          >
            <a-textarea
              v-decorator="['remark', {
                rules: [
                  { max: 200, message: '最多200个字符' },
                ]
              }]"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </a-form-item>
        </a-col>
      </a-form>
    </a-row>
  </a-modal>
</template>

<script>
import {
  cancelAllocateSimCards,
  validateCancelAllocateSimCards
} from '@/api/batch_operation'
import CommonCardInput from '@/components/CardInput/Common'

export default {
  name: 'BatchOperationCancelAllocateSimCardsToAgency',
  components: { CommonCardInput },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    iccids: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      submitting: false,
      form: this.$form.createForm(this, { name: 'cancel_allocate_sim_cards' })
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },

    topAgentId() {
      return this.$store.getters.userAgentId
    }
  },
  methods: {
    checkIccids(rule, value, callback) {
      if (!value || !value.inputValue) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入卡号')
        return
      }

      if (value.validateStatus === 'error') {
        callback(value.errorMsg)
        return
      }

      // eslint-disable-next-line standard/no-callback-literal
      callback()
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          const iccids = values.iccids.data
          validateCancelAllocateSimCards({
            iccids,
            top_agent_id: this.topAgentId
          }).then((validateRes) => {
            if (validateRes.code !== 0) {
              this.submitting = false
              return
            }

            if (!validateRes.data.is_valid) {
              this.form.setFieldsValue({
                iccids: { inputValue: validateRes.data.result }
              })
              this.$nextTick(() => {
                this.$refs.iccidInput.handleCards()
              })
              this.submitting = false
              return
            }

            cancelAllocateSimCards({
              remark: values.remark,
              top_agent_id: this.topAgentId,
              iccids
            }).then((res) => {
              if (res.code === 0) {
                this.isShow = false
                this.$emit('completed')
                this.$success({
                  title: '提交成功',
                  content: (
                    <div>
                      <p>操作成功，具体操作结果请至 【系统查询】-【批量操作查询】 查看</p>
                    </div>
                  )
                })
              }
              this.submitting = false
            })
          })
        }
      })
    }
  }
}
</script>
